import DraggableScroll from "../__page/draggableScroll";
import {VideoPopup} from "../__page/videoPopup"

const $ = jQuery.noConflict();

export default class VideoWithFilters {
    constructor(selector, type) {
        this.block = $('.video-posts-with-filters');
        this.trigger = this.block.find('.single-filter');
        this.readMoreLink = this.block.find('.read-more');
        this.videosWrapper = this.block.find('.video-wrapper');
    }

    init() {
        this.trigger.on('click', (e) => {
            e.preventDefault();
            this.trigger.removeClass('active');
            const that = $(e.delegateTarget);
            that.addClass('active');
            const term = that.data('term');
            const taxonomy = that.data('taxonomy');
            this.ajax(taxonomy, term);
        });

        this.initSlider();

    }

    initSlider() {
        const tiles = this.block.find('.featured-tiles');

        const slider = new DraggableScroll(tiles, {
            infinite: false
        });

        slider.init();

        tiles.find('.link').on('click', (e) => {
            if (slider.isSliding) {
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        })
    }

    ajax(taxonomy, term) {
        $.ajax({
            method: 'POST',
            url: `${WP.apiUrl}video/`,
            data: {
                taxonomy,
                term,
            },
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', WP.apiNonce);
            },
            success: (response) => {
                this.videosWrapper.html(response.content);
                this.readMoreLink.attr('href', response.term_link);
                this.initSlider();
                VideoPopup();
            },
            fail: (response) => {
                console.log('fail', response);
            }
        });
    }
}
